export default __webpack_public_path__ + "static/Cutout-9bc315df870d0c22bf15ef96aecb20eb.mp4";